import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../../api/authApi';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') ?? '';
  const [token, setToken] = useState(tokenFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    setToken(tokenFromUrl);
  }, [tokenFromUrl]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (!token.trim()) {
      setError('Link non valido. Richiedi un nuovo link di recupero.');
      return;
    }
    if (newPassword.length < 6) {
      setError('La password deve essere di almeno 6 caratteri.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Le due password non coincidono.');
      return;
    }
    setLoading(true);
    try {
      await authApi.resetPassword(token.trim(), newPassword);
      setSuccess(true);
      setTimeout(() => nav('/login'), 2000);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Impossibile reimpostare la password.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  if (!tokenFromUrl) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-card-header">
            <div className="auth-card-logo">
              <i className="bi bi-link-45deg" />
            </div>
            <h1 className="auth-card-title">Link non valido</h1>
            <p className="auth-card-subtitle">
              Usa il link ricevuto via email.{' '}
              <Link to="/forgot-password">Richiedi un nuovo link</Link>.
            </p>
          </div>
          <div className="auth-card-body">
            <Link to="/login" className="btn auth-btn-primary">
              <i className="bi bi-box-arrow-in-right me-2" />
              Torna al login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-card-body text-center py-5">
            <div
              className="auth-card-logo mx-auto mb-3"
              style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}
            >
              <i className="bi bi-check-lg fs-3" />
            </div>
            <h2 className="auth-card-title mb-2">Password aggiornata</h2>
            <p className="auth-card-subtitle mb-4">Reindirizzamento al login...</p>
            <div className="spinner-border text-primary" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <div className="auth-card-logo">
            <i className="bi bi-shield-lock-fill" />
          </div>
          <h1 className="auth-card-title">Nuova password</h1>
          <p className="auth-card-subtitle">
            Inserisci la nuova password (min. 6 caratteri).
          </p>
        </div>

        <div className="auth-card-body">
          <form onSubmit={submit} className="auth-form">
            <div className="mb-3">
              <label htmlFor="reset-password" className="form-label">Nuova password</label>
              <input
                id="reset-password"
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="new-password"
                minLength={6}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="reset-confirm" className="form-label">Conferma password</label>
              <input
                id="reset-confirm"
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="new-password"
              />
            </div>
            {error && (
              <div className="alert alert-danger auth-alert mb-3" role="alert">
                <i className="bi bi-exclamation-circle me-2" />
                {error}
              </div>
            )}
            <button
              className="btn auth-btn-primary mb-0"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Aggiornamento...
                </>
              ) : (
                <>
                  <i className="bi bi-shield-check me-2" />
                  Imposta nuova password
                </>
              )}
            </button>
          </form>

          <div className="auth-links text-center">
            <p className="mb-0">
              <Link to="/login">Torna al login</Link>
              {' · '}
              <Link to="/forgot-password">Richiedi nuovo link</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
